import { IProduct } from '../../../interfaces/Product.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface IGetProductByIdParams {
  productId: string;
  searchParam?: {
    fields?: string;
  };
}

export const getProductById = ({ productId, searchParam = {} }: IGetProductByIdParams): Promise<IProduct> => {
  const URLSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`/market/products/${productId}?${URLSearchParams}`);
};
